import { render, staticRenderFns } from "./PageNotFoundView.vue?vue&type=template&id=5d63444b&scoped=true&"
import script from "./PageNotFoundView.vue?vue&type=script&lang=js&"
export * from "./PageNotFoundView.vue?vue&type=script&lang=js&"
import style0 from "./PageNotFoundView.vue?vue&type=style&index=0&id=5d63444b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d63444b",
  null
  
)

export default component.exports